// extracted by mini-css-extract-plugin
export var BlueCyan = "features-module--BlueCyan--ba318";
export var BlueTeal = "features-module--BlueTeal--8f405";
export var CyanBlue = "features-module--CyanBlue--35834";
export var CyanTeal = "features-module--CyanTeal--664b1";
export var Description = "features-module--Description--41a19";
export var Features = "features-module--Features--ac11a";
export var FeaturesContainer = "features-module--FeaturesContainer--09b78";
export var Picture = "features-module--Picture--d0c7b";
export var Row = "features-module--Row--4f0b5";
export var SmallTitle = "features-module--SmallTitle--021ac";
export var TealBlue = "features-module--TealBlue--4b8ac";
export var TealCyan = "features-module--TealCyan--f1374";
export var VisualCard = "features-module--VisualCard--c3e87";
export var VisualIcon = "features-module--VisualIcon--1f923";
export var VisualShell = "features-module--VisualShell--90817";